import React, { useState } from "react"
import AsyncSelect from 'react-select/async';
import { fetchCities } from "../../services/api/influencer";
import { debounce } from "lodash";
import { Coordinates } from "../../types/address";
interface CitySelectionProps {
    value: string,
    onChange: (selected: string) => void,
}

const CitySelection: React.FC<CitySelectionProps> = ({ value, onChange }) => {

    const _loadCitiesSuggestions = (query: string, callback: any) => {
        if (!query || query.length < 3) return callback([]);

        fetchCities(query)
            .then(resp => callback(resp.map((item: string) => ({ value: item, label: item })))).catch(() => callback([]))
    };

    const loadCitiesSuggestions = debounce(_loadCitiesSuggestions, 200);

    const getSelectedCities = () => {
        if (value) {
            return { label: value, value }
        }
    }

    const handleChange = (selected: any) => {
        onChange(selected?.value ?? '')
    }

    return (
        <div>
            <div className="profile-input position-relative">
                <label className="font-12 d-block profile-input-label">
                    City <span className="text-danger">*</span>
                </label>
                <AsyncSelect isClearable noOptionsMessage={ () => 'Start Typing...' } classNamePrefix={'influns-app'} className="profile-input-form-control-wrapper" placeholder='Location' menuPlacement='top' cacheOptions loadOptions={loadCitiesSuggestions} value={getSelectedCities()} onChange={handleChange} />
                {/* <Select isClearable classNamePrefix={'influns-app'} className="profile-input-form-control-wrapper" isDisabled={declined} placeholder='Location' onMenuOpen={onMenuOpen} onMenuClose={onMenuClose} menuPlacement='bottom' menuShouldScrollIntoView options={nearbyCities} value={getSelectedCities()} onChange={handleChange} /> */}
            </div>
        </div>

    )
}

export default CitySelection